export function isDebugEnabled() {
  return localStorage.getItem('growthbook_debug') === 'true';
}
